import React from 'react'
import { useStaticQuery, graphql, Link, navigate } from 'gatsby'
import { withPrismicPreview } from 'gatsby-plugin-prismic-previews'
import { renderImageUrl } from '../../utility.js'
import PropTypes from 'prop-types'
import Icon from '../icon/icon.js'
import Button from '../button/button-link.js'
import ActivityTable from './activityTable.js'
import EventsBlock from './eventsBlock.js'
import splashIcon from '../../images/splash-icon.png'

import * as styles from './index.module.css'

class Header extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      searchDisplay: false,
      searchValue: '',
      open: false,
      activeDropdowns: [],
      isMobile: false
    }

    this.searchFormRef = React.createRef();
    this.searchInputRef = React.createRef();

    this.handleChange = this.handleChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleClickSearchShow = this.handleClickSearchShow.bind(this);
    this.handleClickSearchHide = this.handleClickSearchHide.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.clearDropdownClasses = this.clearDropdownClasses.bind(this);
  }



  componentDidMount() {
    if (typeof window !== 'undefined') {
      this.setState({ isMobile: window.innerWidth < 1200 });
      window.addEventListener('resize', this.handleResize);

      window.$('#navbarSupportedContent').on('show.bs.collapse', () => {
        this.setState({ open: true })
      })
      window.$('#navbarSupportedContent').on('hidden.bs.collapse', () => {
        this.setState({ open: false })
      })
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.handleResize);
    }
  }

  handleResize() {
    if (typeof window !== 'undefined') {
      const isMobile = window.innerWidth < 1200;
      if (isMobile !== this.state.isMobile) {
        this.setState({ isMobile, activeDropdowns: [] });
        this.clearDropdownClasses();
      }
    }
  }

  clearDropdownClasses() {
    const openDropdowns = document.querySelectorAll('.dropdown-open');
    const shownMenus = document.querySelectorAll('.dropdown-menu.show');

    openDropdowns.forEach(element => {
      element.classList.remove('dropdown-open');
    });

    shownMenus.forEach(element => {
      element.classList.remove('show');
    });
  }

  handleChange(ev) {
    this.setState({ searchValue: ev.target.value })
  }

  handleKeyDown(ev) {
    /* console.log('handleKeyDown', ev) */
    if (ev.key === 'Enter') {
      navigate('/search/', {
        state: { searchValue: this.state.searchValue },
      })
    }
  }

  handleClickSearchShow(ev) {
    ev.preventDefault()
    this.setState({ searchDisplay: true })
    setTimeout(() => {
      document.body.addEventListener('click', this.handleClickSearchHide)
    }, 200)
  }

  handleClickSearchHide(ev) {
    if (
      this.searchFormRef.current &&
      !this.searchFormRef.current.contains(ev.target)
    ) {
      this.setState({ searchDisplay: false })
      document.body.removeEventListener('click', this.handleClickSearchHide)
    }
  }

  toggleDropdown(dropdownId, ev) {
    this.setState((prevState) => {
      ev.preventDefault();
      const isActive = prevState.activeDropdowns.includes(dropdownId);
      let newActiveDropdowns;
      if (prevState.isMobile) {
        newActiveDropdowns = isActive
          ? prevState.activeDropdowns.filter((id) => id !== dropdownId)
          : [...prevState.activeDropdowns, dropdownId];
      } else {
        newActiveDropdowns = isActive ? [] : [dropdownId];
      }

      setTimeout(() => {
        const spanElement = document.querySelector(`#${dropdownId}Menu span`);
        if (spanElement) {
          if (isActive) {
            spanElement.classList.remove('dropdown-open');
          } else {
            spanElement.classList.add('dropdown-open');
          }
        }
        const dropdownMenuElement = document.querySelector(`#${dropdownId} .dropdown-menu`);
        if (dropdownMenuElement) {
          if (isActive) {
            dropdownMenuElement.classList.remove('show');
          } else {
            dropdownMenuElement.classList.add('show');
          }
        }
      }, 0);

      return {
        activeDropdowns: newActiveDropdowns,
      };
    });
  }

  render() {
    let { siteTitle, section, data } = this.props
    const doc = data?.allPrismicSiteStructure?.nodes[0].data

    /* console.log('header DOC -->>', doc) */
    /* console.log('header proppies ---->>', this.props) */

    let animalsImageStyle,
      campsImageStyle,
      rentImageStyle = {}
    if (doc) {
      animalsImageStyle = {
        backgroundImage: `url( ${renderImageUrl(doc.nav_animals_image)} )`,
      }
      campsImageStyle = {
        backgroundImage: `url( ${renderImageUrl(
          doc.nav_camps_and_tours_image
        )} )`,
      }
      rentImageStyle = {
        backgroundImage: `url( ${renderImageUrl(doc.nav_rent_the_zoo_image)} )`,
      }
    }
    let { searchDisplay } = this.state

    const isSectionActive = (currentSection, classes) => {
      if (section === currentSection) {
        return `${classes} active`
      }
      return classes
    }

    const isDropdownActive = (dropdownId) => {
      return this.state.activeDropdowns.includes(dropdownId);
    };

    let navClasses = `${styles.kczooNavbar} kczoo-navbar navbar navbar-expand-xl`
    if (this.state.open) {
      navClasses += ` ${styles.kczooNavbarOpen}`
    }

    if (typeof window !== 'undefined') {
      document.addEventListener(
        'click',
        function () {
          setTimeout(() => {
            let targetClass = document.getElementsByClassName('dropdown show')
            let targetText = document.getElementById('giraffeBanner')
            let targetImage = document.getElementById('bannerImage')
            let targetCaret = document.getElementById('bannerCaret')
            const bannerStylesDimText = {
              transitionDuration: '0.2s',
              color: 'rgba(255, 255, 255, 0.5)',
            }
            const bannerStylesDimImg = {
              transitionDuration: '0.2s',
              opacity: '0.5',
            }
            const bannerStyles = {
              transitionDuration: '0.2s',
              color: 'rgba(255, 255, 255, 1.0)',
              opacity: '1.0',
            }

            // So it does not freak out if the aquarium bar is not there
            if (targetText && targetImage && targetCaret) {
              if (targetClass.length > 0) {
                Object.assign(targetText.style, bannerStylesDimText)
                Object.assign(targetImage.style, bannerStylesDimImg)
                Object.assign(targetCaret.style, bannerStylesDimImg)
              }
              if (targetClass.length < 1) {
                Object.assign(targetText.style, bannerStyles)
                Object.assign(targetImage.style, bannerStyles)
                Object.assign(targetCaret.style, bannerStyles)
              }
            }
          })
        },
        100
      )
    }

    return (
      <>
        <nav className={navClasses}>
          <div>
            <Link
              className={`${styles.kczooBrand} navbar-brand`}
              style={{ position: 'relative', zIndex: 101 }}
              to="/"
            >
              <img
                src="/images/logo-kczooaquarium-horz-color.png"
                alt="Kansas City Zoo & Aquarium Logo"
                width="144"
                className={styles.kczooLogo}
              />
            </Link>
          </div>

          <button
            className={`${styles.navbarToggler} navbar-toggler collapsed`}
            type="button"
            id="myCollapsible"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className={`${styles.togglerIcon}`}></span>
          </button>

          <div
            className={`${styles.navbarCollapse} collapse navbar-collapse`}
            id="navbarSupportedContent"
          >
            <div
              className={`${styles.btnGroup} btn-group`}
              role="group"
              aria-label=""
            >
              <Link to="/tickets-and-pricing" className={`${styles.btn} btn`}>
                GET TICKETS
              </Link>
              <Link to="/daily-schedule" className={`${styles.btn} btn`}>
                DAILY SCHEDULE
              </Link>
              <Link to="/zoo-map" className={`${styles.btn} btn`}>
                VIEW MAP
              </Link>
            </div>

            <div className={`${styles.navbarCollapseSearch} form`}>
              <div
                className={`${styles.navbarCollapseSearchInputGroup} input-group`}
              >
                <input
                  type="text"
                  aria-label='Search'
                  className={`${styles.searchInputCollapse} form-control`}
                  placeholder="Search"
                  ref={this.searchInputRef}
                  value={this.state.value}
                  onChange={this.handleChange}
                  onKeyDown={this.handleKeyDown}
                />
                <div className="input-group-append">
                  <span className={`${styles.searchIcon} input-group-text`}>
                    <Icon
                      icon="search"
                      width="21"
                      height="21"
                      color="ZOO GREEN"
                      alt="Search"
                    />
                  </span>
                </div>
              </div>
            </div>

            <ul className={`${styles.navPrimary} navbar-nav mr-auto`}>
              <li
                className={isSectionActive(
                  'visit',
                  `${styles.navPrimaryItem} nav-item dropdown`
                )}
              >
                <a
                  className={`${styles.navLink} ${styles.navLinkPrimary} dropdown-toggle`}
                  href="#"
                  id="visitMenu"
                  role="button"
                  aria-haspopup="true"
                  aria-expanded={isDropdownActive('visit')}
                  onClick={(ev) => this.toggleDropdown('visit', ev)}
                >
                  Visit
                  <span className={styles.chevronIcon}></span>
                </a>
                <div
                  className={`${styles.dropdownMenu} ${styles.dropdownMenuPrimary} dropdown-menu ${isDropdownActive('visit') ? 'show' : ''}`}
                  aria-labelledby="visitMenu"
                >
                  <div className={styles.dropdownMenuBody}>
                    <div
                      className={`${styles.dropdownMenuAside} ${styles.dropdownMenuAsideVisit} ${styles.dropdownMenuAsideAlignBottom}`}
                    >
                      <div className={styles.dropdownMenuAsideInner}>
                        <div className="mb-4">
                          <Icon icon="map" color="WHITE" width="80" />
                        </div>
                        <Button text="Zoo Map" url="/zoo-map" size="small" />
                      </div>
                    </div>
                    <div className={styles.dropdownMenuContentTight}>
                      <div className="row no-gutters">
                        {/* LEFT COLUMN */}
                        <div className="col-xl-6">
                          <Link
                            to="/zoo-map"
                            className={`${styles.dropdownItem} d-block d-xl-none dropdown-item`}
                          >
                            Zoo Map
                          </Link>
                          <Link
                            to="/tickets-and-pricing"
                            className={`${styles.dropdownItem} dropdown-item`}
                          >
                            Tickets
                          </Link>
                          <Link
                            to="/visit/dining"
                            className={`${styles.dropdownItem} dropdown-item`}
                          >
                            Dining
                          </Link>
                          <Link
                            to="/rides-and-transportation"
                            className={`${styles.dropdownItem} dropdown-item`}
                          >
                            Rides &amp; Transportation
                          </Link>
                          <Link
                            to="/hours-location-parking"
                            className={`${styles.dropdownItem} dropdown-item`}
                          >
                            Hours, Locations &amp; Parking
                          </Link>

                        </div>
                        {/* RIGHT COLUMN */}
                        <div className="col-xl-6">

                          <Link
                            to="/fyi/accessibility"
                            className={`${styles.dropdownItem} dropdown-item`}
                          >
                            Accessibility
                          </Link>

                          <Link
                            to="/visit/guest-services"
                            className={`${styles.dropdownItem} dropdown-item`}
                          >
                            Guest Services
                          </Link>
                          <Link
                            to="/visit/zoo-policies"
                            className={`${styles.dropdownItem} dropdown-item`}
                          >
                            Zoo Policies
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>

              {/* ANIMALS NAV SECTION */}
              <li
                className={isSectionActive(
                  'animals',
                  `${styles.navPrimaryItem} nav-item dropdown`
                )}
              >
                <a
                  className={`${styles.navLink} ${styles.navLinkPrimary} dropdown-toggle`}
                  href="#"
                  id="animalsMenu"
                  role="button"
                  aria-haspopup="true"
                  aria-expanded={isDropdownActive('animals')}
                  onClick={(ev) => this.toggleDropdown('animals', ev)}
                >
                  Animals
                  <span className={styles.chevronIcon}></span>
                </a>
                <div
                  className={`${styles.dropdownMenu} ${styles.dropdownMenuPrimary} dropdown-menu ${isDropdownActive('animals') ? 'show' : ''}`}
                  aria-labelledby="animalsMenu"
                >
                  <div className={styles.dropdownMenuBody}>
                    <div
                      className={`${styles.dropdownMenuAside} ${styles.dropdownMenuAsideAnimals} ${styles.dropdownMenuAsideAlignBottom}`}
                    >
                      <div className={styles.dropdownMenuAsideInner}>
                        <div className="mb-4">
                          <Icon icon="penguin" color="WHITE" width="65" />
                        </div>
                        <Button
                          text="Animals A-Z"
                          url="/animals"
                          size="small"
                        />
                      </div>
                    </div>
                    <div className={styles.dropdownMenuContentTight}>
                      <div className="row no-gutters">
                        <div className="col-xl-6">
                          <Link
                            to="/animals"
                            className={`${styles.dropdownItem} d-block d-xl-none dropdown-item`}
                          >
                            Animals A-Z
                          </Link>
                          <Link
                            to="/aquarium"
                            className={`${styles.dropdownItem} dropdown-item`}
                          >
                            Sobela Ocean Aquarium
                          </Link>
                          <Link
                            to="/exhibit/helzberg-penguin-plaza"
                            className={`${styles.dropdownItem} dropdown-item`}
                          >
                            Helzberg Penguin Plaza
                          </Link>
                          <Link
                            to="/wild-beginnings"
                            className={`${styles.dropdownItem} dropdown-item`}
                          >
                            Wild Beginnings
                          </Link>
                        </div>
                        <div className="col-xl-6">
                          <Link
                            to="/exhibit/orangutan-canopy"
                            className={`${styles.dropdownItem} dropdown-item`}
                          >
                            Orangutan Canopy
                          </Link>
                          <Link
                            to="/exhibit/stingraybay"
                            className={`${styles.dropdownItem} dropdown-item`}
                          >
                            Stingray Bay
                          </Link>
                          <Link
                            to="/animal-cams"
                            className={`${styles.dropdownItem} dropdown-item`}
                          >
                            Animal Cameras
                          </Link>
                          <Link
                            to="/animals/virtual-animal-chats"
                            className={`${styles.dropdownItem} dropdown-item`}
                          >
                            Virtual Animal Chats
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>

              {/* SCHEDULE NAV SECTION */}
              <li
                className={isSectionActive(
                  'activities',
                  `${styles.navPrimaryItem} nav-item dropdown`
                )}
              >
                <a
                  className={` ${styles.navLink} ${styles.navLinkPrimary} dropdown-toggle`}
                  href="#"
                  id="activitiesMenu"
                  role="button"
                  aria-haspopup="true"
                  aria-expanded={isDropdownActive('activities')}
                  onClick={(ev) => this.toggleDropdown('activities', ev)}
                >
                  Schedule
                  <span className={styles.chevronIcon}></span>
                </a>
                <div
                  className={`${styles.dropdownMenu} ${styles.dropdownMenuPrimary} dropdown-menu ${isDropdownActive('activities') ? 'show' : ''}`}
                  aria-labelledby="activitiesMenu"
                >
                  <div className={styles.dropdownMenuBody}>
                    <div
                      className={`${styles.dropdownMenuAside} ${styles.dropdownMenuAsideSchedule} ${styles.dropdownMenuAsideAlignBottom}`}
                    >
                      <div className={styles.dropdownMenuAsideInner}>
                        <div className="mb-4">
                          <Icon icon="clockBold" color="WHITE" width="70" />
                        </div>
                        <Button text="Activities" url="/daily-schedule" size="smallLongText" />
                      </div>
                    </div>
                    <div className={styles.dropdownMenuContentSec}>
                      <EventsBlock {...this.props} />
                    </div>
                  </div>
                </div>
              </li>

              {/* CAMPS NAV SECTION */}
              <li
                className={isSectionActive(
                  'camps',
                  `${styles.navPrimaryItem} nav-item dropdown`
                )}
              >
                <a
                  className={` ${styles.navLink} ${styles.navLinkPrimary} dropdown-toggle`}
                  href="#"
                  id="campsMenu"
                  role="button"
                  aria-haspopup="true"
                  aria-expanded={isDropdownActive('camps')}
                  onClick={(ev) => this.toggleDropdown('camps', ev)}
                >
                  Camps
                  <span className={styles.chevronIcon}></span>
                </a>
                <div
                  className={`${styles.dropdownMenu} ${styles.dropdownMenuPrimary} dropdown-menu ${isDropdownActive('camps') ? 'show' : ''}`}
                  aria-labelledby="campsMenu"
                >
                  <div className={styles.dropdownMenuBody}>
                    <div
                      className={`${styles.dropdownMenuAside} ${styles.dropdownMenuAsideCamps} ${styles.dropdownMenuAsideAlignBottom}`}
                    >
                      <div className={styles.dropdownMenuAsideInner}>
                        <div className="mb-4">
                          <Icon icon="tent" color="WHITE" width="80" />
                        </div>
                        <Button text="Camp Scholarships" url="/fyi/break-camp-scholarships" size="smallLongText" />
                      </div>
                    </div>
                    <div className={styles.dropdownMenuContentTight}>
                      <div className="row no-gutters">
                        <div className="col-xl-6">
                          <Link
                            to="/fyi/aquarium-glamping-overnight"
                            className={`${styles.dropdownItem} dropdown-item`}
                          >
                            Aquarium Overnight
                          </Link>
                          <Link
                            to="/overnight/indoor-overnights"
                            className={`${styles.dropdownItem} dropdown-item`}
                          >
                            Indoor Overnight
                          </Link>
                          <Link
                            to="/overnight/outdoor-overnights"
                            className={`${styles.dropdownItem} dropdown-item`}
                          >
                            Outdoor Overnight
                          </Link>
                          <Link
                            to="/overnight/public-overnight"
                            className={`${styles.dropdownItem} dropdown-item`}
                          >
                            Public Overnight
                          </Link>
                        </div>
                        <div className="col-xl-6">
                          <Link
                            to="/camp/schools-out-camp"
                            className={`${styles.dropdownItem} dropdown-item`}
                          >
                            Schools Out Camps
                          </Link>
                          <Link
                            to="/scouts"
                            className={`${styles.dropdownItem} dropdown-item`}
                          >
                            Scouts
                          </Link>
                          <Link
                            to="/camp/summer-break-camp"
                            className={`${styles.dropdownItem} dropdown-item`}
                          >
                            Summer Camps
                          </Link>
                          <Link
                            to="/camp/winter-and-spring-break-camp"
                            className={`${styles.dropdownItem} dropdown-item`}
                          >
                            Winter & Spring Camps
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>

              {/* RENT THE ZOO NAV SECTION */}
              <li
                className={isSectionActive(
                  'rent',
                  `${styles.navPrimaryItem} nav-item dropdown`
                )}
              >
                <a
                  className={` ${styles.navLink} ${styles.navLinkPrimary} dropdown-toggle`}
                  href="#"
                  id="rentMenu"
                  role="button"
                  aria-haspopup="true"
                  aria-expanded={isDropdownActive('rent')}
                  onClick={(ev) => this.toggleDropdown('rent', ev)}
                >
                  Rent the Zoo
                  <span className={styles.chevronIcon}></span>
                </a>
                <div
                  className={`${styles.dropdownMenu} ${styles.dropdownMenuPrimary} dropdown-menu dropdown-menu-right ${isDropdownActive('rent') ? 'show' : ''}`}
                  aria-labelledby="rentMenu"
                >
                  <div className={styles.dropdownMenuBody}>
                    <div className={`${styles.dropdownMenuAside} ${styles.dropdownMenuAsideRent} ${styles.dropdownMenuAsideAlignBottom}`}>
                      <div className={styles.dropdownMenuAsideInner}>
                        <div className="mb-4">
                          <Icon icon="cake2" color="WHITE" width="70" />
                        </div>
                        <Button text="Picnics" url="/picnics" size="small" />
                      </div>
                    </div>
                    <div className={styles.dropdownMenuContentTight}>
                      <div className="row">
                        <div className="col-xl-6">
                          <Link
                            to="/plan-your-party"
                            className={`${styles.dropdownItem} dropdown-item`}
                          >
                            Birthdays
                          </Link>
                          <Link
                            to="/weddings"
                            className={`${styles.dropdownItem} dropdown-item`}
                          >
                            Weddings
                          </Link>
                          <Link
                            to="/picnics"
                            className={`${styles.dropdownItem} dropdown-item`}
                          >
                            Picnics
                          </Link>
                        </div>
                        <div className="col-xl-6">
                          <Link
                            to="/evening-rentals"
                            className={`${styles.dropdownItem} dropdown-item`}
                          >
                            Evening Rentals
                          </Link>
                          <Link
                            to="/corporate-meetings"
                            className={`${styles.dropdownItem} dropdown-item`}
                          >
                            Corporate Meetings
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>

              {/* EDUCATION NAV SECTION */}
              <li
                className={isSectionActive(
                  'education',
                  `${styles.navPrimaryItem} nav-item dropdown`
                )}
              >
                <a
                  className={`${styles.navLink} ${styles.navLinkPrimary} dropdown-toggle`}
                  href="#"
                  id="educationMenu"
                  role="button"
                  aria-haspopup="true"
                  aria-expanded={isDropdownActive('education')}
                  onClick={(ev) => this.toggleDropdown('education', ev)}
                >
                  Education
                  <span className={styles.chevronIcon}></span>
                </a>
                <div
                  className={`${styles.dropdownMenu} ${styles.dropdownMenuPrimary} dropdown-menu dropdown-menu-right ${isDropdownActive('education') ? 'show' : ''}`}
                  aria-labelledby="educationMenu"
                >
                  <div className={styles.dropdownMenuBody}>
                    <div
                      className={`${styles.dropdownMenuAside} ${styles.dropdownMenuAsideEducation} ${styles.dropdownMenuAsideAlignBottom}`}
                    >
                      <div className={styles.dropdownMenuAsideInner}>
                        <div className="mb-4">
                          <Icon icon="chalkboard" color="WHITE" width="80" />
                        </div>
                        <Button text="Field Trips" url="/education/field-trips" size="small" />
                      </div>
                    </div>
                    <div className={styles.dropdownMenuContentTight}>
                      <div className="row no-gutters">
                        <div className="col-xl-6">
                          <Link
                            to="/education/field-trips"
                            className={`${styles.dropdownItem} dropdown-item`}
                          >
                            Field Trips
                          </Link>
                          <Link
                            to="/zoomobile"
                            className={`${styles.dropdownItem} dropdown-item`}
                          >
                            Zoomobile
                          </Link>
                          <Link
                            to="/homeschool"
                            className={`${styles.dropdownItem} dropdown-item`}
                          >
                            <span style={{ whiteSpace: 'nowrap' }}>
                              Homeschool
                            </span>
                          </Link>
                          <Link
                            to="/preschool"
                            className={`${styles.dropdownItem} dropdown-item`}
                          >
                            <span style={{ whiteSpace: 'nowrap' }}>
                              Preschool
                            </span>
                          </Link>
                        </div>
                        <div className="col-xl-6">
                          <Link
                            to="/zooed"
                            className={`${styles.dropdownItem} dropdown-item`}
                          >
                            <span style={{ whiteSpace: 'nowrap' }}>
                              ZooED <br />
                              (Jackson/Clay County)
                            </span>
                          </Link>
                          <Link
                            to="/education/nature-rangers"
                            className={`${styles.dropdownItem} dropdown-item`}
                          >
                            Nature Rangers
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>

              {/* CONSERVATION NAV SECTION */}
              <li
                className={isSectionActive(
                  'conservation',
                  `${styles.navPrimaryItem} nav-item dropdown`
                )}
              >
                <a
                  className={`${styles.navLink} ${styles.navLinkPrimary} dropdown-toggle`}
                  href="#"
                  id="conservationMenu"
                  role="button"
                  aria-haspopup="true"
                  aria-expanded={isDropdownActive('conservation')}
                  onClick={(ev) => this.toggleDropdown('conservation', ev)}
                >
                  Conservation
                  <span className={styles.chevronIcon}></span>
                </a>
                <div
                  className={`${styles.dropdownMenu} ${styles.dropdownMenuPrimary} dropdown-menu dropdown-menu-right ${isDropdownActive('conservation') ? 'show' : ''}`}
                  aria-labelledby="conservationMenu"
                >
                  <div className={styles.dropdownMenuBody}>
                    <div
                      className={`${styles.dropdownMenuAside} ${styles.dropdownMenuAsideConservation} ${styles.dropdownMenuAsideAlignBottom}`}
                    >
                      <div className={styles.dropdownMenuAsideInner}>
                        <div className="mb-4">
                          <Icon icon="leaf" color="WHITE" width="80" />
                        </div>
                        <Button text="Projects" url="/conservation-projects/field-research-projects" size="small" />
                      </div>
                    </div>
                    <div className={styles.dropdownMenuContentTight}>
                      <div className="row no-gutters">
                        <div className="col-xl-6">
                          <Link
                            to="/conservation/how-you-can-help"
                            className={`${styles.dropdownItem} dropdown-item`}
                          >
                            Our Commitment
                          </Link>
                          <Link
                            to="/conservation-projects/field-research-projects"
                            className={`${styles.dropdownItem} dropdown-item`}
                          >
                            Field & Research Projects
                          </Link>
                          <Link
                            to="/conservation-projects/green-initiatives"
                            className={`${styles.dropdownItem} dropdown-item`}
                          >
                            Green Initiatives
                          </Link>
                        </div>
                        <div className="col-xl-6">
                          <Link
                            to="/conservation-projects/aza-safe-programs"
                            className={`${styles.dropdownItem} dropdown-item`}
                          >
                            AZA SAFE Programs
                          </Link>
                          <Link
                            to="/conservation-projects/partnerships"
                            className={`${styles.dropdownItem} dropdown-item`}
                          >
                            <span style={{ whiteSpace: 'nowrap' }}>
                              Partnerships
                            </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>

            {/* SECONDARY NAV SECTION */}
            <div className={`${styles.navbarRight}`}>
              <ul className={`${styles.navUtility} navbar-nav ml-auto`}>
                <li className={`${styles.navUtilityItem} nav-item`}>
                  <Link
                    to="/tickets-and-pricing"
                    className={`${styles.navLink} ${styles.navLinkUtility} ${styles.navLinkUtilityGreen} ${styles.navLinkButton}`}
                  >
                    Buy Tickets
                  </Link>
                </li>
                <li className={`${styles.navUtilityItem} nav-item`}>
                  <Link
                    to="/form/donate-to-the-zoo-form"
                    className={`${styles.navLink} ${styles.navLinkUtility} ${styles.navLinkUtilityBlue} ${styles.navLinkButton}`}
                  >
                    Donate
                  </Link>
                </li>
              </ul>
              {searchDisplay && (
                <div
                  className={`${styles.searchForm} form`}
                  ref={this.searchFormRef}
                >
                  <div className={`${styles.searchInputGroup} input-group`}>
                    <div className="input-group-prepend">
                      <span className={`${styles.searchIcon} input-group-text`}>
                        <Icon
                          icon="searchBold"
                          width="21"
                          height="21"
                          color="ZOO GREEN"
                          alt="Search"
                        />
                      </span>
                    </div>
                    <input
                      type="text"
                      aria-label="search"
                      className={`${styles.searchInput} form-control`}
                      placeholder="Enter search terms"
                      ref={this.searchInputRef}
                      value={this.state.value}
                      onChange={this.handleChange}
                      onKeyDown={this.handleKeyDown}
                    />
                  </div>
                </div>
              )}
              {!searchDisplay && (
                <ul className={`${styles.navSecondary} navbar-nav`}>
                  <li
                    className={isSectionActive(
                      'conservation',
                      `${styles.navSecondaryItem} nav-item dropdown`
                    )}
                  >
                    <a
                      className={`${styles.navLink} ${styles.navLinkSecondary} dropdown-toggle`}
                      href="/memberships"
                      id="membershipsMenu"
                      role="button"
                      aria-haspopup="true"
                      aria-expanded={isDropdownActive('memberships')}
                    >
                      MEMBERSHIPS
                    </a>
                  </li>
                  <li className="mb-0">
                    <p className={`${styles.navLink} ${styles.navLinkSecondary} ${styles.navLinkSecondaryDivider}`}>|</p>
                  </li>
                  <li
                    className={isSectionActive(
                      'support',
                      `${styles.navSecondaryItem} nav-item dropdown`
                    )}
                  >
                    <a
                      className={`${styles.navLink} ${styles.navLinkSecondary} dropdown-toggle`}
                      href="#"
                      id="supportMenu"
                      role="button"
                      aria-haspopup="true"
                      aria-expanded={isDropdownActive('support')}
                      onClick={(ev) => this.toggleDropdown('support', ev)}
                    >
                      SUPPORT US
                      <span className={styles.chevronIcon}></span>
                    </a>
                    <div
                      className={`${styles.dropdownMenu} dropdown-menu dropdown-menu-right ${isDropdownActive('support') ? 'show' : ''}`}
                      aria-labelledby="supportMenu"
                    >
                      <div className={styles.dropdownMenuContentSec}>
                        <Link
                          to="/form/donate-to-the-zoo-form"
                          className={`${styles.dropdownItem} ${styles.dropdownItemSec} dropdown-item`}
                        >
                          General Donations
                        </Link>
                        <Link
                          to="/support-us/adopt-a-wild-child"
                          className={`${styles.dropdownItem} ${styles.dropdownItemSec} dropdown-item`}
                        >
                          Adopt A Wild Child
                        </Link>
                        <Link
                          to="/donate/giving-plaques"
                          className={`${styles.dropdownItem} ${styles.dropdownItemSec} dropdown-item`}
                        >
                          Plaques
                        </Link>
                        <Link
                          to="/support-us/planned-giving-and-stock"
                          className={`${styles.dropdownItem} ${styles.dropdownItemSec} dropdown-item`}
                        >
                          Planned Giving & Stocks
                        </Link>
                        <Link
                          to="/support-us/memorials-and-tributes"
                          className={`${styles.dropdownItem} ${styles.dropdownItemSec} dropdown-item`}
                        >
                          Memorials & Tributes
                        </Link>
                        <Link
                          to="/volunteers"
                          className={`${styles.dropdownItem} ${styles.dropdownItemSec} dropdown-item`}
                        >
                          Volunteer
                        </Link>
                        <Link
                          to="/support-us/corporate-sponsors"
                          className={`${styles.dropdownItem} ${styles.dropdownItemSec} dropdown-item`}
                        >
                          Corporate Sponsors
                        </Link>
                        <Link
                          to="/fyi/wish-list"
                          className={`${styles.dropdownItem} ${styles.dropdownItemSec} dropdown-item`}
                        >
                          Wish List
                        </Link>
                        <Link
                          to="/jazzoo"
                          className={`${styles.dropdownItem} ${styles.dropdownItemSec} dropdown-item`}
                        >
                          Jazzoo
                        </Link>
                      </div>
                    </div>
                  </li>
                  <li className={`${styles.navUtilityItem} nav-item`}>
                    <a
                      className={`${styles.navLink} ${styles.navLinkUtility}`}
                      onClick={this.handleClickSearchShow}
                      href="#"
                      title="Search"
                    >
                      <Icon
                        icon="searchBold"
                        width="21"
                        height="21"
                        color="white"
                        alt="Search"
                      />
                    </a>
                  </li>
                </ul>
              )}
            </div>
            <div className={styles.kczooNavbarFooter}>
              <Button text="Buy Tickets" url="/tickets-and-pricing" />
              <Button text="Donate" url="/form/donate-to-the-zoo-form" />
            </div>
          </div>
        </nav>
        {!this.props?.location?.href?.includes('zoo-map') && (
          <Link
            to="/giraffe-habitat"
            id="giraffeBanner"
            className={styles.giraffeBar}
          >

            <span className={styles.giraffeBar__primary_text}>We’re creating a new SPOT for giraffes! </span>
            <span className={styles.giraffeBar__action_link}>Learn More </span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="6.413"
              height="10.828"
              viewBox="0 0 6.413 10.828"
              id="bannerCaret"
            >
              <path
                id="Path_9757"
                data-name="Path 9757"
                d="M12687.83,8954.8l4,4-4,4"
                transform="translate(-12686.416 -8953.387)"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
            </svg>
          </Link>
        )}
      </>
    );
  }
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

const HeaderStaticQuery = (props) => {
  const siteStructureQuery = useStaticQuery(
    graphql`
      query {
        allPrismicSiteStructure {
          nodes {
            data {
              nav_animals_image {
                url
                alt
              }
              nav_camps_and_tours_image {
                alt
                url
              }
              nav_rent_the_zoo_image {
                alt
                url
              }
            }
            id
            tags
            type
            uid
          }
        }
      }
    `
  )

  return <Header data={siteStructureQuery} {...props} />
}

export default HeaderStaticQuery
